import { CircularProgress, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import {
  gridSizeConst2,
  gridSizeConst4,
  gridSizeConst6,
  gridSizeMdLg12,
  gridSizeMdLg6,
} from '@/shared';
import {
  CustomAutocompleteArrStringNoForm,
  CustomAutocompleteMultipleArrString,
  CustomAutocompleteNoForm,
  CustomTextField,
  SampleCheckbox,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { PermissionsEnum } from '@/auth/interfaces';
import { useFetchCitiesEnabled, useFetchZones } from '@/shared/actions/erp';
import {
  useCheckPermissions,
  useTableServerSideFiltering,
} from '@/shared/hooks';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
import { City, Zone } from '@/shared/interfaces';
import { FilterAltOff, Refresh } from '@mui/icons-material';
import { DatePicker, esES, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useForm } from 'react-hook-form';
import { Actividad, ActividadesPagingRes, TecnicosSoftnet, TipoActividadSoftnet, TipoActividadSoftnetEnum, useFetchSeguimientoActividadesSoftnet, useFetchTecnicosSoftnet } from '@/shared/actions/erp/operaciones/softnet-seguimientoactividades';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import GeneralTableInfiniteScroll from '@/shared/components/ui/GeneralTableInfiniteScroll';
import { useColumnsAgendamientos } from '@/erp/operaciones/agendamiento/shared/hooks';
// import ModalSendToBitacora from '@/erp/operaciones/agendamiento/pages/tables/Seguimiento de Actividades/ModalSeguimientoFlotaPlanificador';
// import ModalSeguimientoFlotaPlanificador from '@/erp/operaciones/agendamiento/pages/tables/Seguimiento de Actividades/ModalSeguimientoFlotaPlanificador';

type ValoresFiltrosEstadoInformeType = {
  label: string;
  value: string;
  items: Actividad[];
  activo: boolean;
}



const SeguimientoActividadesVentas: React.FC= () => {
  useCheckPermissions(PermissionsEnum.api_view_agendamiento);

  const [allData, setAllData] = useState<ActividadesPagingRes | null>(null);
//   const [openModalSeguimientoFlotaPlanificador, setOpenModalSeguimientoFlotaPlanificador] = useState(false);
//   const [dataRowSelected, setDataRowSelected] = useState<any>(null);
  const [refreshButton, setRefreshButton] = useState<boolean>(true);
  const [firstRender, setFirstRender] = useState<boolean>(true);
//   const [openModalSendToBitacora, setOpenModalSendToBitacora] = useState(false);
  const [tecnicosSoftnetFetched, setTecnicosSoftnetFetched] = useState<TecnicosSoftnet[]>([]);
  const [valoresFiltrosEstadoInforme, setValoresFiltrosEstadoInforme] = useState<ValoresFiltrosEstadoInformeType[]>([
    {
      label: "PENDIENTE",
      value: "Pendiente",
      items: [],
      activo: false
    },
    {
      label: "EXITOSO",
      value: "Exitoso",
      items: [],
      activo: false
    },
    {
      label: "FALLIDO",
      value: "Fallido",
      items: [],
      activo: false
    },
    {
      label: "RECORDINAR",
      value: "Recordinar",
      items: [],
      activo: false
    }
  ]);
  // const { handleMethodChange, valueTab } = useTabsFormOnly({});

  
  const { filterObject, setFilterObject } =
    useTableServerSideFiltering();

  const formSeguimientoPyL = useForm<any>({
    // defaultValues:{
    //   flota:"",
    //   // fecha_desde: dayjs().format("YYYY-MM-DD"),
    //   // fecha_hasta: dayjs().format("YYYY-MM-DD"),
    //   tipo_actividad: []
    // }
  })

  ///* table
  const {
    pagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: seguimientoActividadesPagingRes,
    isLoading: isLoadingSeguimientoActividades,
    status: statusSeguimientoActividades,
  } = useFetchSeguimientoActividadesSoftnet({
    enabled: refreshButton,//&& !!formSeguimientoPyL?.getValues().flota
    params: {
      ...filterObject,
      page: pageIndex + 1,
      page_size: 1000,
      fecha_desde: dayjs(formSeguimientoPyL?.getValues().fecha_desde).format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
      fecha_hasta: dayjs(formSeguimientoPyL?.getValues().fecha_hasta).format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
      filtrar_empleado_referencia: true,
    },
  });



  const {
    data: tecnicosSoftnet,
    isLoading: isLoadingTecnicos,
  } = useFetchTecnicosSoftnet({
    enabled: true,
  });



  const {
    data: ciudades,
    isLoading: isLoadingCiudades,
  } = useFetchCitiesEnabled({
    params: {
      page_size: 2800,
    },
    enabled: true,
  });

  const {
    data: zonas,
    isLoading: isLoadingZonas,
  } = useFetchZones(
    {
      page_size: 2800,
    },
    true,
  );

  // const {
  //   data: flotas,
  //   isLoading: isLoadingFlotas,
  // } = useFetchFlotas(
  //   {
  //     page_size: 2800,
  //   },
  //   true,
  // );

  useEffect(() => {
    if(!firstRender){
      setFirstRender(true);
      return;
    }
    if(firstRender){
      setTimeout(() => {
        setRefreshButton(true);
      }, 500);
      if(refreshButton && seguimientoActividadesPagingRes?.code === 200){
        toast.success("Datos cargados exitosamente")
      }
    }

  }, [refreshButton])

  ///* columns
  const { 
    agendamientosSeguimientoSupVentas
  } = useColumnsAgendamientos();

  useEffect(() => {
    if(
      !formSeguimientoPyL?.watch("fecha_desde") &&
      !formSeguimientoPyL?.watch("fecha_hasta") &&
      !formSeguimientoPyL?.watch("ciudad") &&
      !formSeguimientoPyL?.watch("zona") &&
      !formSeguimientoPyL?.watch("flota") &&
      !formSeguimientoPyL?.watch("tipo_actividad") &&
      !formSeguimientoPyL?.watch("busqueda_string")
    ){
      return;
    }
    formSeguimientoPyL?.reset({
      ...formSeguimientoPyL?.getValues(),
      Pendiente: false,
      Exitoso: false,
      Fallido: false,
      Recordinar: false,
    })


    const filterTipoActividad = formSeguimientoPyL?.getValues().tipo_actividad && formSeguimientoPyL?.getValues().tipo_actividad?.length > 0 ? 
    JSON.parse(formSeguimientoPyL?.getValues().tipo_actividad)?.map((item: any) => {
      switch(item){
        case TipoActividadSoftnetEnum.INSTALACION:
          return 1
        case TipoActividadSoftnetEnum.MIGRACION:
          return 2
        case TipoActividadSoftnetEnum.TRASLADO:
          return 3
        case TipoActividadSoftnetEnum.VISITAS:
          return 4
        case TipoActividadSoftnetEnum.RETIROS:
          return 5
        default:
          return undefined
      }
    }).filter((item: any) => item !== undefined)?.toString()
    : undefined;

    setFilterObject({...filterObject,
      fecha_desde: dayjs(formSeguimientoPyL?.getValues().fecha_desde).format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
      fecha_hasta: dayjs(formSeguimientoPyL?.getValues().fecha_hasta).format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
      id_ciudad: formSeguimientoPyL?.getValues().ciudad || undefined,
      id_zona: formSeguimientoPyL?.getValues().zona || undefined,
      numero: formSeguimientoPyL?.getValues().flota? formSeguimientoPyL?.getValues().flota : undefined,//"T-405","T-405",// || 
      tipo_actividad: filterTipoActividad,
      // tipo_busqueda_string: formSeguimientoPyL?.getValues().tipo_busqueda_string,
      // busqueda_string: formSeguimientoPyL?.getValues().busqueda_string,
    })
  }, [
    formSeguimientoPyL?.watch("fecha_desde"),
    formSeguimientoPyL?.watch("fecha_hasta"),
    formSeguimientoPyL?.watch("ciudad"),
    formSeguimientoPyL?.watch("zona"),
    formSeguimientoPyL?.watch("flota"),
    formSeguimientoPyL?.watch("tipo_actividad"),
    formSeguimientoPyL?.watch("busqueda_string"),
  ])

  useEffect(() => {
    if(statusSeguimientoActividades === "error"){
      toast.error("No se han podido cargar los datos")
      return;
    }
    
    if(seguimientoActividadesPagingRes?.data){
      setValoresFiltrosEstadoInforme((prev: ValoresFiltrosEstadoInformeType[]) => prev.map((item: ValoresFiltrosEstadoInformeType) => {
        const itemsFiltered = seguimientoActividadesPagingRes?.data?.data?.filter((itemFetched: Actividad) => itemFetched.estado_tecnico === item.value)
        return {
          ...item,
          items: itemsFiltered
        }
      }))
      setAllData(seguimientoActividadesPagingRes?.data)
    }
  }, [seguimientoActividadesPagingRes?.data])



  useEffect(() => {
    const { Pendiente, Exitoso, Fallido, Recordinar } = formSeguimientoPyL?.watch() ?? {};

    const filteredData = seguimientoActividadesPagingRes?.data?.data?.filter((item: Actividad) => {
      if (!Pendiente && !Exitoso && !Fallido && !Recordinar) return true;

      return (
        (Pendiente && item.estado_tecnico === "Pendiente") ||
        (Exitoso && item.estado_tecnico === "Exitoso") ||
        (Fallido && item.estado_tecnico === "Fallido") ||
        (Recordinar && item.estado_tecnico === "Recordinar")
      );
    })
    console.log(filteredData)
    const dataFiltered = {
      count: seguimientoActividadesPagingRes?.data?.count,
      next: seguimientoActividadesPagingRes?.data?.next,
      previous: seguimientoActividadesPagingRes?.data?.previous,
      data: filteredData,
      conteo_por_fecha: seguimientoActividadesPagingRes?.data?.conteo_por_fecha,
    }
    setAllData(dataFiltered as ActividadesPagingRes)
    
  }, [
    formSeguimientoPyL?.watch()?.Pendiente,
    formSeguimientoPyL?.watch()?.Exitoso,
    formSeguimientoPyL?.watch()?.Fallido,
    formSeguimientoPyL?.watch()?.Recordinar,
  ])

  useEffect(() => {
    if(tecnicosSoftnet){
      setTecnicosSoftnetFetched(tecnicosSoftnet?.data)
    }
  }, [tecnicosSoftnet])


  


  return (
    <SingleTableBoxScene title={'Seguimiento de Actividades'}>
      <LocalizationProvider 
      dateAdapter={AdapterDayjs}
      adapterLocale="es"
      localeText={
        esES.components.MuiLocalizationProvider.defaultProps.localeText
      }
      >
      <Grid {...gridSizeMdLg12} container  spacing={2} paddingY={2}>
        <Grid item {...gridSizeMdLg6}>
          <Typography variant="h6">Parámetros de Búsqueda</Typography>
        </Grid>
        <Grid container item {...gridSizeMdLg6} justifyContent={"flex-end"} alignItems={"center"} p={2}>
          <Grid item>
          <Tooltip title="Limpiar Filtros">
              <IconButton
                onClick={() => {
                  formSeguimientoPyL.reset({
                    fecha_desde: dayjs(),
                    fecha_hasta: dayjs(),
                    ciudad: undefined,
                    zona: undefined,
                    flota: "0",
                    tipo_actividad: undefined,
                    busqueda_string: undefined,
                  })
                  setRefreshButton(false)
                }}
              ><FilterAltOff/></IconButton>
            </Tooltip>
            <Tooltip title="Refrescar">
              <IconButton
                onClick={() => setRefreshButton(false)}
              ><Refresh/></IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid container item {...gridSizeMdLg6} justifyContent={"flex-end"} alignItems={"center"} spacing={2}>
            <Grid item {...gridSizeMdLg6}>
              <CustomAutocompleteArrStringNoForm
                label="Tipo Búsqueda"
                options={["Identificación", "Nombre Cliente"]}
                defaultValue={formSeguimientoPyL?.getValues().tipo_busqueda_string}
                onChangeValue={(value) => formSeguimientoPyL.setValue("tipo_busqueda_string", value)}
                required
                size={gridSizeMdLg12}
              />
            </Grid>
            <Grid item {...gridSizeMdLg6}>
              <CustomTextField
                label={formSeguimientoPyL?.getValues().tipo_busqueda_string === "Identificación" ? "Identificación" : "Nombre Cliente"}
                name="busqueda_string"
                control={formSeguimientoPyL.control}
                error={!!formSeguimientoPyL?.formState.errors.busqueda_string?.message}
                helperText={formSeguimientoPyL?.formState.errors.busqueda_string?.message as string}
                defaultValue={formSeguimientoPyL?.getValues().busqueda_string}
                size={gridSizeMdLg12}
              />
            </Grid>

            <Grid item {...gridSizeMdLg6}>
              <DatePicker
                label="Desde"
                value={formSeguimientoPyL?.getValues()?.fecha_desde}
                onChange={(value) =>
                  formSeguimientoPyL.setValue('fecha_desde', value)
                }
                sx={{width: "100%"}}
                format="DD/MM/YYYY" 
              />
            </Grid>
            <Grid item {...gridSizeMdLg6}>
              <DatePicker
                label="Hasta"
                value={formSeguimientoPyL?.getValues().fecha_hasta}
                onChange={(value) =>
                  formSeguimientoPyL.setValue('fecha_hasta', value)
                }
                sx={{width: "100%"}}
                format="DD/MM/YYYY" 
              />
            </Grid>

            <CustomAutocompleteNoForm
              label="Ciudad Instalación"
              options={ciudades?.data?.data?.filter((item:City) => !!parseInt(item.numero_referencia!)) || []}
              valueKey="nombre"
              actualValueKey="codigo"
              onChangeRawValue={(value:City) =>
                formSeguimientoPyL.setValue('ciudad', value.numero_referencia)
              }
              isLoadingData={isLoadingCiudades}
              defaultValue={""}
              size={gridSizeMdLg6}
            />
            <CustomAutocompleteNoForm
              label="Zona Instalación"
              options={zonas?.data?.data?.filter((item:Zone) => !!parseInt(item.numero_referencia!)) || []}
              valueKey="nombre"
              actualValueKey="codigo"
              onChangeRawValue={(value:Zone) =>
                formSeguimientoPyL.setValue('zona', value.numero_referencia)
              }
              isLoadingData={isLoadingZonas}
              defaultValue={""}
              size={gridSizeMdLg6}
            />




            <Grid item {...gridSizeMdLg12}>
            {
              refreshButton?
                <CustomAutocompleteNoForm
                  label="Flota"
                  options={tecnicosSoftnetFetched|| []}
                  valueKey="nombre_tecnico"
                  actualValueKey="cod_tecnico"
                  onChangeRawValue={(value:TecnicosSoftnet) =>
                    formSeguimientoPyL.setValue('flota', value.cod_tecnico)
                  }
                  value={formSeguimientoPyL?.getValues().flota}
                  isLoadingData={isLoadingTecnicos}
                  defaultValue={""}
                  size={gridSizeMdLg12}
                />
              :<CircularProgress/>
            }
            </Grid>
            
            <Grid item {...gridSizeMdLg12}>
            {
              refreshButton?
                <CustomAutocompleteMultipleArrString
                  name="tipo_actividad"
                  label="Tipo Actividad"
                  options={TipoActividadSoftnet}
                  onChangeValue={(value) =>{
                    formSeguimientoPyL.setValue('tipo_actividad', value)
                  }}
                  isLoadingData={false}
                  helperText={undefined}
                  defaultValue={formSeguimientoPyL?.getValues().tipo_actividad}
                  size={gridSizeMdLg12}
                />
                :<CircularProgress/>
              }          
            </Grid>
        </Grid>
        

        <Grid item container {...gridSizeMdLg6}>
          <Grid container item {...gridSizeMdLg12} sx={{marginBottom: 1}}>
            <Grid item sx={{borderBottom: "1px solid #464646"}} {...gridSizeConst6}><Typography variant='h6'>Estado Informe</Typography></Grid>
            <Grid item sx={{borderBottom: "1px solid #464646"}} {...gridSizeConst4}><Typography variant='h6'>Cantidad</Typography></Grid>
            <Grid item sx={{borderBottom: "1px solid #464646"}} {...gridSizeConst2}><Typography variant='h6'>Ver</Typography></Grid>
          </Grid>
          {
            valoresFiltrosEstadoInforme.map((item: any, index: number) => (
              <Grid container item {...gridSizeMdLg12} key={`estado-informe-${index}`}>
                <Grid item sx={{borderBottom: "1px solid #8b8b8b", alignContent: "center", height:50}} {...gridSizeConst6}><Typography variant='h6'>{item?.label}</Typography></Grid>
                <Grid item sx={{borderBottom: "1px solid #8b8b8b", alignContent: "center", height:50}} {...gridSizeConst4}><Typography variant='h6'>{item?.items && item.items?.length}</Typography></Grid>
                <Grid item sx={{borderBottom: "1px solid #8b8b8b", alignContent: "center", height:50}} {...gridSizeConst2}>
                  <SampleCheckbox
                    label={""}
                    control={formSeguimientoPyL.control}
                    name={item.value}
                    defaultValue={false}
                    sizeCheck={"medium"}
                  />
                </Grid>
              </Grid>
            ))
          }
        </Grid>
      </Grid>
          <GeneralTableInfiniteScroll
            enableGlobalFilter={true}
            columns={agendamientosSeguimientoSupVentas}
            allData={allData?.data || []}
            chunk={500}
            isLoading={
              !!!allData?.data?.length && isLoadingSeguimientoActividades?
              true
              :false
            }
            // customActionBtnSpace={(row)=>
            //   <>
            //     <Tooltip title='Bitácora'>
            //       <IconButton
            //         color="primary"
            //         onClick={() => {
            //           setDataRowSelected(row)
            //           setOpenModalSendToBitacora(true)
            //         }}
            //       >
            //         <Message/>
            //       </IconButton>
            //     </Tooltip>

            //     <Tooltip title='Ver Actividades'>
            //       <IconButton
            //         color="primary"
            //         onClick={() => {
            //           setDataRowSelected(row)
            //           setOpenModalSeguimientoFlotaPlanificador(true)
            //         }}
            //       >
            //         <CalendarMonth/>
            //       </IconButton>
            //     </Tooltip>
            //   </>
            // }
            enableHoverEffect={false}
            paintRow={(row)=>{
              if(row.estado_tecnico === "Recordinar"){
                return "#F2F279"
              }else if(row.estado_tecnico === "Fallido"){
                return "#F27979"
              }else if(row.activacion === "Activado"){
                return "#81F279"
              }
              return ""
            }}
            rowCount={allData?.conteo_por_fecha?
              Object.values(allData?.conteo_por_fecha!).reduce((acc, val) => parseInt(acc as string) + parseInt(val as string), 0) as number
            : 0}
          />

          {/* <GeneralTable<Actividad>
            columns={agendamientosSeguimientoSupVentas}
            //seguimientoActividadesPagingRes?.data?.data
            data={allData?.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={
              allData?.conteo_por_fecha?
              Object.values(allData?.conteo_por_fecha!).reduce((acc, val) => parseInt(acc as string) + parseInt(val as string), 0) as number
            : 0}
            // // // actions ========
            enableColumnActions={true}
            showCustomActionBtnSpace={true}
            canEdit = {false}
            customActionBtnSpace={(row)=>
              <>
                <Tooltip title='Bitácora'>
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setDataRowSelected(row)
                      setOpenModalSendToBitacora(true)
                    }}
                  >
                    <Message/>
                  </IconButton>
                </Tooltip>

                <Tooltip title='Ver Actividades'>
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setDataRowSelected(row)
                      setOpenModalSeguimientoFlotaPlanificador(true)
                    }}
                  >
                    <CalendarMonth/>
                  </IconButton>
                </Tooltip>
              </>
            }
            enableHoverEffect={true}
            paintRow={(row)=>{
              if(row.estado_tecnico === "Recordinar"){
                return "#F2F279"
              }else if(row.estado_tecnico === "Fallido"){
                return "#F27979"
              }else if(row.activacion === "Activado"){
                return "#81F279"
              }
              return ""
            }}
          /> */}
      {/* <ModalSeguimientoFlotaPlanificador
        data={dataRowSelected}
        open={openModalSeguimientoFlotaPlanificador}
        setOpen={setOpenModalSeguimientoFlotaPlanificador}
      />
      <ModalSendToBitacora
        data={dataRowSelected}
        open={openModalSendToBitacora}
        setOpen={setOpenModalSendToBitacora}
      /> */}
      </LocalizationProvider>
    </SingleTableBoxScene>

  );
};

export default SeguimientoActividadesVentas;
